<template>
  <div>

    <a-layout :style="{height: '100vh'}">
      <a-layout>
        <a-layout-sider
        collapsible
        v-model="collapsed"
        >
          <img v-if="collapsed" class="logo" src="@/assets/logo_menu_small.png"/>
          <img v-else class="logo" src="@/assets/logo_menu_dark.png"/>
          <SideMenu></SideMenu>
        </a-layout-sider>

          <div style="overflow-x: auto; width: 100%">
            <router-view/>
          </div>

        <Soon></Soon>

      </a-layout>
    </a-layout>

  <cookie-law theme="dark-lime"></cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import SideMenu from "@/components/SideMenu";
import Soon from "@/components/Soon";

export default {
  name: "Main",
  components: {
    CookieLaw,
    SideMenu,
    Soon,
  },
  created() {
    this.$store.commit('prefs/loadUserPreferences');
    this.$store.dispatch('userdata/fetchUserdata');
  },
  data() {
    return {
      collapsed: false,
    }
  }
}
</script>

<style scoped>

.logo {
  margin: 16px;
}

</style>

